(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-confirm.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-confirm.js');
'use strict';

const {
  useEffect
} = React;
const {
  FULFILLED,
  REJECTED
} = svs.myProfile.constants.thunkStatus;
const Button = svs.ui.ReactButton;
const {
  getCustomersPreferences,
  setForceSaveEmail,
  setVerifyEmail
} = svs.myProfile.react.store.pdPreferences.actions;
const {
  showTechnicalError,
  showHandledError,
  showBaseError
} = svs.myProfile.react.shared.dialogs;
const {
  showResendConfirmationDialog,
  showAlreadyVerifed
} = svs.myProfile.react.pages.myInformation.myInformation.emailDialogs;
const {
  putEmailVerifyAsync
} = svs.myProfile.react.pages.myInformation.myInformationService;
const trackEventEmailConfirmation = () => {
  const track = {
    category: 'My Profile',
    action: 'new email confirmation'
  };
  svs.components.analytics.trackEvent(track);
};
const trackEventEmailLink = () => {
  const track = {
    category: 'My Profile',
    action: 'new email link'
  };
  svs.components.analytics.trackEvent(track);
};

const EmailConfirm = () => {
  const dispatch = ReactRedux.useDispatch();
  const isPnp = svs.core.config.data.svsconfig.site === 'momang';
  const {
    playerCustomizedSettings
  } = ReactRedux.useSelector(state => state.playerCustomizedSettings);
  const {
    email,
    customerId
  } = playerCustomizedSettings;
  const {
    status: playerCustomizedSettingsStatus
  } = (playerCustomizedSettings === null || playerCustomizedSettings === void 0 ? void 0 : playerCustomizedSettings.playerCustomizedSettingsStatus) || {};
  useEffect(() => {
    dispatch(getCustomersPreferences());
  }, [dispatch]);
  useEffect(() => {
    if (playerCustomizedSettingsStatus === FULFILLED || playerCustomizedSettingsStatus === REJECTED) {
      if (!customerId) {
        showTechnicalError();
      }
    }
  }, [customerId, playerCustomizedSettingsStatus]);
  const showDefaultError = () => {
    showTechnicalError('Ett fel inträffade när ett nytt e-postmeddelande skulle skickas, försök igen senare eller kontakta Kundservice 0770 - 11 11 11');
  };
  const handleError = error => {
    const code = error.code;
    if (code === 12510) {
      showAlreadyVerifed();
      dispatch(setVerifyEmail());
    } else if (code === 10058) {
      showBaseError("Du har nyligen best\xE4llt en bekr\xE4ftelsel\xE4nk till ".concat(email.toLowerCase()), 'Kontrollera din skräppost om du inte hittar mejlet. Om 15 minunter kan du begära en ny länk.');
    } else if (code === 100005) {
      showHandledError("Du har blivit utloggad. Var god logga in och f\xF6rs\xF6k igen!");
    } else {
      svs.myProfile.logger.warn("Unhandled error code when sending email confirmation link: ".concat(error));
      showDefaultError();
    }
  };
  const handleSendConfirmationEmail = async () => {
    try {
      const {
        error
      } = await putEmailVerifyAsync();
      if (error) {
        return handleError(error);
      }
      trackEventEmailConfirmation();
      showResendConfirmationDialog();
    } catch (error) {
      svs.myProfile.logger.warn("Unhandled error code when sending email confirmation link: ".concat(error));
      showDefaultError();
    }
  };
  const handleChangeEmail = () => {
    trackEventEmailLink();
    dispatch(setForceSaveEmail(true));
  };
  return React.createElement(React.Fragment, null, React.createElement("p", {
    className: "f-center margin-top-2"
  }, "Bekr\xE4fta din e-post genom att anv\xE4nda l\xE4nken vi har skickat till adressen du har angivit ."), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    inverted: isPnp,
    onClick: handleSendConfirmationEmail,
    transparent: true
  }, "Skicka ny bekr\xE4ftelsel\xE4nk"), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    inverted: isPnp,
    onClick: handleChangeEmail,
    transparent: true
  }, "Ange ny e-post"));
};
svs.myProfile.react.pages.myInformation.myInformation.email.EmailConfirm = EmailConfirm;

 })(window);